import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationComponent } from '../views/pages/common/notification/notification.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private snackBar: MatSnackBar
  ) { }

  openSnackBar(message: string) {
    this.snackBar.openFromComponent(NotificationComponent, {
      // duration: 5000, // Commented in favor of global configuration
      data: { message: message}      
    });
  }
}
